// extracted by mini-css-extract-plugin
export default {"map":"Map_map__7doVP","large":"Map_large__ICYJU","roundIcon":"Map_roundIcon__FaE3j"};